<template>
    <div id="app">
        <main role="main" class="main-cont">
            <div class="row m-0 main-section">
                <div class="col-sm-12 right-section homebody">
                    <div class="row" style="margin-top:30px;">
                        <div class="col-sm-2 ">
                        </div>
                        <div class="col-sm-8 card bg-light">
                            <h4 class="mb-4 label-font-design"> GAAP </h4>
                            <div class="panelDiv">
                                <div class="container">
                                    <div class="row col-sm-12">
                                        <div class="col-sm-6">
                                            <h5 class="mb-3" style="font-weight: bold;">Client Name *</h5>
                                        </div>
                                        <div class="col-sm-6">
                                        </div>
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-6">
                                            <select v-model="selectedClient" class="col-sm-11 selectarrow" name="selectedClient" v-validate="'required'" :class="{'is-invalid':errors.has('selectedClient')}">
                                                <option value="" selected disabled>Please Select Client Name</option>
                                                <option v-for="clt in clientmap" :key="clt.id" v-bind:value="{ id: clt.id, text: clt.clientName }">{{ clt.clientName }}</option>
                                            </select>
                                            <div>
                                                <span v-show="errors.has('selectedClient')" class="text-danger">Please select the client name</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-6">
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row col-sm-12">
                                        <div class="row col-sm-6">
                                            <div class="col-sm-12">
                                                <h5 class="mb-3" style="font-weight: bold;">From Date (dd-MM-yyyy)*</h5>
                                            </div>
                                            <div class="col-sm-12">
                                                <input type="date" class="form-control border input-control-border" id="startdate" v-model="startdate" placeholder="Enter Start Date" name="startdate" style="border-color: gray !important;" v-validate="'required'" :class="{'is-invalid':!isDateValid || errors.has('startdate')}">
                                            </div>
                                        </div>
                                        <div class="row col-sm-6">
                                            <div class="col-sm-12">
                                                <h5 class="mb-3 " style="font-weight: bold;">To Date  (dd-MM-yyyy)*</h5>
                                            </div>
                                            <div class="col-sm-12">
                                                <input type="date" class="form-control border input-control-border" id="enddate" v-model="enddate" placeholder="Enter End Date" name="enddate" style="border-color: gray !important;" v-validate="'required'" :class="{'is-invalid':!isDateValid || errors.has('enddate')}">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <span v-show="errors.has('startdate') && errors.has('enddate')" class="text-danger">Date range is mandatory</span>
                                        <span v-show="errors.has('startdate') && !errors.has('enddate')" class="text-danger ">Please select the start date</span>
                                        <span v-show="errors.has('enddate') && !errors.has('startdate')" class="text-danger">Please select the end date</span>
                                        <span v-show="!isDateValid" class="text-danger"> End date must be greater than start date</span>
                                    </div>

                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-6">
                                            <h5 style="font-weight: bold;">US GAAP Sheet (.xlsx) </h5>
                                        </div>
                                        <div class="col-sm-6">
                                        </div>
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-9">
                                            <div class="file-upload">
                                                <div class="file-select" :class="{'is-invalid':errors.has('chooseUsFile')}">
                                                    <div class="file-select-name" id="noFileUS">
                                                        {{USUploadedFile}}
                                                    </div>
                                                    <input type="file"
                                                           name="chooseUsFile"
                                                           id="USGAAPFile"
                                                           ref="USGAAPFile"
                                                           v-on:change="handleUSGAAPFile()"
                                                           v-validate="`required|size:${fileSize}`"
                                                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
                                                    <div class="file-select-button" id="fileName">Browse</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-1">
                                        </div>
                                        <div class="col-sm-2">
                                            <button id="btnUS" class="btn btn-primary" v-bind:disabled="btnUSDisabled" v-on:click="Fetch($event)">Upload</button>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <span v-show="errors.has('chooseUsFile')" class="text-danger">Please upload the file</span>
                                    </div>
                                    <!-- Fetched US Section -->
                                    <div v-if="renderUSGAAPDiv" class="row col-sm-12">
                                        <div v-for="(USFileData, index) in USFileDetails.fileDetails" v-bind:key="index.id" class="row" v-bind:class="{boxed:isBoxed}">
                                            <div class="row col-sm-12">
                                                <div class="col-sm-12">
                                                    <label style="font-weight:bold;color:lightblack;" class="mb-3 col-form-label">{{USFileData.fileName}}</label>
                                                </div>
                                            </div>
                                            <div v-bind:id="'USbox' + USFileSheetData.id" v-for="(USFileSheetData, index) in USFileData.sheetDetails" v-bind:key="index.id" class="row" v-bind:class="{boxed:isBoxed}">
                                                <div class="row col-sm-12">
                                                    <div class="col-sm-1">
                                                    </div>
                                                    <div class="col-sm-2">
                                                        <label style="font-weight:bold;color:lightblack;" class="mb-3 col-form-label">{{USFileSheetData.labelName}}</label>
                                                    </div>
                                                    <div class="col-sm-7">
                                                        <select class="form-control col-sm-8 selectarrow " v-model="USFileSheetData.sheetName">
                                                            <option v-for="(worksheets, value) in USsheetNames" v-bind:key="value">
                                                                {{ worksheets.sheetname }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-2">
                                                        <button class="btn" v-if="!isSkipUsDisabled" v-bind:class="{skipbtntype:btnskip}" v-bind:id="'USskip' + USFileSheetData.id" v-on:click="handleUSSkipEvent($event,USFileSheetData.id)">Skip</button>
                                                    </div>
                                                </div>
                                                <div class="row col-sm-12">
                                                    <div class="col-sm-3">
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <div class="row col-sm-9 col-md-7 dp-inline-fx">
                                                            <div class="col-sm-6  pl-0">
                                                                <div class="mt-2 new-form">
                                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                                        <input v-model="USFileSheetData.columnStart"
                                                                               class="floating-input"
                                                                               type="number"
                                                                               placeholder=" "
                                                                               name="colStart"
                                                                               v-validate="'required|colParameter'"
                                                                               v-on:keypress="isNumber($event)">
                                                                        <span class="highlight"></span>
                                                                        <label>Start Column</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6  pl-0">
                                                                <div class="mt-2 new-form">
                                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                                        <input v-model='USFileSheetData.columnEnd'
                                                                               class="floating-input"
                                                                               type="number"
                                                                               placeholder=" "
                                                                               name="colEnd"
                                                                               v-validate="'required|colParameter'"
                                                                               v-on:keypress="isNumber($event)">
                                                                        <span class="highlight"></span>
                                                                        <label>End Column</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row col-sm-12">
                                                    <div class="col-sm-3">
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <div class="row col-sm-9 col-md-7 dp-inline-fx">
                                                            <div class="col-sm-6  pl-0">
                                                                <div class="mt-2 new-form">
                                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                                        <input v-model='USFileSheetData.rowStart'
                                                                               class="floating-input"
                                                                               type="number"
                                                                               placeholder=" "
                                                                               name="rowStart"
                                                                               v-validate="'required|rowParameter'"
                                                                               v-on:keypress="isNumber($event)">
                                                                        <span class="highlight"></span>
                                                                        <label>Start Row</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6  pl-0">
                                                                <div class="mt-2 new-form">
                                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                                        <input v-model='USFileSheetData.rowEnd'
                                                                               class="floating-input"
                                                                               type="number"
                                                                               placeholder=" "
                                                                               name="rowEnd"
                                                                               v-validate="'required|rowParameter'"
                                                                               v-on:keypress="isNumber($event)">
                                                                        <span class="highlight"></span>
                                                                        <label>End Row</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row col-sm-12">
                                                    <div col-sm-3></div>
                                                    <div col-sm-9>
                                                        <span v-show="errors.has('colStart')||errors.has('colEnd')||errors.has('rowStart')||errors.has('rowEnd')"
                                                              class="text-danger">Please enter the mandatory parameters</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-6">
                                            <h5 style="font-weight: bold;">BR GAAP Sheet (.xlsx) </h5>
                                        </div>
                                        <div class="col-sm-6">
                                        </div>
                                    </div>
                                    <div class="row col-sm-12">
                                        <div class="col-sm-9">
                                            <div class="file-upload">
                                                <div class="file-select" :class="{'is-invalid':errors.has('chooseBrFile')}">
                                                    <div class="file-select-name" id="noFileBR">
                                                        {{this.BRUploadedFile}}
                                                    </div>
                                                    <input type="file"
                                                           name="chooseBrFile"
                                                           id="BRGAAPFile"
                                                           ref="BRGAAPFile"
                                                           v-on:change="handleBRGAAPFile()"
                                                           v-validate="`required|size:${fileSize}`"
                                                           accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                           :class="{'is-invalid':errors.has('chooseBrFile')}">
                                                    <div class="file-select-button" id="fileName">Browse</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-sm-1">
                                        </div>
                                        <div class="col-sm-2">
                                            <button id="btnBR" class="btn btn-primary" v-bind:disabled="btnBRDisabled" v-on:click="Fetch($event)">Upload</button>
                                        </div>
                                    </div>
                                    <div class="col-sm-12">
                                        <span v-show="errors.has('chooseBrFile')" class="text-danger">Please upload the file</span>
                                    </div>
                                    <!-- Fetching BR Details -->
                                    <div v-if="renderBRGAAPDiv" class="row col-sm-12">
                                        <div v-for="(BRFileData, index) in BRFileDetails.fileDetails" v-bind:key="index.id" class="row" v-bind:class="{boxed:isBoxed}">
                                            <div class="row col-sm-12">
                                                <div class="col-sm-12">
                                                    <label style="font-weight:bold;color:lightblack;" class="mb-3 col-form-label">{{BRFileData.fileName}}</label>
                                                </div>
                                            </div>
                                            <div v-bind:id="'BRbox' + BRFileSheetData.id" v-for="(BRFileSheetData, index) in BRFileData.sheetDetails" v-bind:key="index.id" class="row" v-bind:class="{boxed:isBoxed}">
                                                <div class="row col-sm-12">
                                                    <div class="col-sm-1">
                                                    </div>
                                                    <div class="col-sm-2">
                                                        <label style="font-weight:bold;color:lightblack;" class="mb-3 col-form-label">{{BRFileSheetData.labelName}}</label>
                                                    </div>
                                                    <div class="col-sm-7">
                                                        <select class="form-control col-sm-8 selectarrow " v-model="BRFileSheetData.sheetName">
                                                            <option v-for="(worksheets, value) in BRsheetNames" v-bind:key="value">
                                                                {{ worksheets.sheetname }}
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-2">
                                                        <button class="btn" v-if="!isSkipBrDisabled" v-bind:class="{skipbtntype:btnskip}" v-bind:id="'BRskip' + BRFileSheetData.id" v-on:click="handleBRSkipEvent($event,BRFileSheetData.id)" :disabled="isSkipBrDisabled">Skip</button>
                                                    </div>
                                                </div>
                                                <div class="row col-sm-12">
                                                    <div class="col-sm-3">
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <div class="row col-sm-9 col-md-7 dp-inline-fx">
                                                            <div class="col-sm-6 pl-0">
                                                                <div class="mt-2 new-form">
                                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                                        <input v-model="BRFileSheetData.columnStart"
                                                                               class="floating-input"
                                                                               type="number"
                                                                               placeholder=" "
                                                                               name="colStart"
                                                                               v-validate="'required|colParameter'"
                                                                               v-on:keypress="isNumber($event)">
                                                                        <span class="highlight"></span>
                                                                        <label>Start Column</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6 pl-0">
                                                                <div class="mt-2 new-form">
                                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                                        <input v-model='BRFileSheetData.columnEnd'
                                                                               class="floating-input"
                                                                               type="number"
                                                                               placeholder=" "
                                                                               name="colEnd"
                                                                               v-validate="'required|colParameter'"
                                                                               v-on:keypress="isNumber($event)">
                                                                        <span class="highlight"></span>
                                                                        <label>End Column</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row col-sm-12">
                                                    <div class="col-sm-3">
                                                    </div>
                                                    <div class="col-sm-9">
                                                        <div class="row col-sm-9 col-md-7 dp-inline-fx">
                                                            <div class="col-sm-6 pl-0">
                                                                <div class="mt-2 new-form">
                                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                                        <input v-model='BRFileSheetData.rowStart'
                                                                               class="floating-input"
                                                                               type="number"
                                                                               placeholder=" "
                                                                               name="rowStart"
                                                                               v-validate="'required|rowParameter'"
                                                                               v-on:keypress="isNumber($event)">
                                                                        <span class="highlight"></span>
                                                                        <label>Start Row</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="col-sm-6  pl-0">
                                                                <div class="mt-2 new-form">
                                                                    <div class="floating-label d-flex flex-column flex-md-row">
                                                                        <input v-model='BRFileSheetData.rowEnd'
                                                                               class="floating-input"
                                                                               type="number"
                                                                               placeholder=" "
                                                                               name="rowEnd"
                                                                               v-validate="'required|rowParameter'"
                                                                               v-on:keypress="isNumber($event)">
                                                                        <span class="highlight"></span>
                                                                        <label>End Row</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row col-sm-12">
                                                    <div col-sm-3></div>
                                                    <div col-sm-9>
                                                        <span v-show="errors.has('colStart')||errors.has('colEnd')||errors.has('rowStart')||errors.has('rowEnd')"
                                                              class="text-danger">Please enter the mandatory parameters</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row">
                                        <div class="col text-center">
                                            <button class="btn btn-primary" v-on:click="Generate" :disabled="errors.any()">Generate Reconciliation</button>
                                        </div>
                                    </div>
                                    <div v-if="showGaapError" class="col sm-6 text-center alert alert-danger alert-dismissible fade show" style="margin: 5px 250px; width: 300px">
                                        <button type="button" class="close" data-dismiss="alert">&times;</button>
                                        <strong> GAAP generation Failed !! </strong>
                                    </div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="floating-label d-flex flex-column flex-md-row"></div>
                                    <div class="row" v-if="renderDownloadFileDiv">
                                        <div class="col-sm-3 col-md-3 ">
                                        </div>
                                        <div class="col-sm-6 col-md-6 alert alert-success success-msg">
                                            <strong>
                                                File generated successfully !!
                                                <br />
                                                <a :href="generatedFileName" class="alert-link" style="cursor: pointer;">Click here to download</a>
                                            </strong>
                                        </div>
                                        <div class="col-sm-3 col-md-3">
                                        </div>
                                    </div>
                                    <div v-if="loading">
                                        <img class="progressLoader" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2 ">
                </div>
            </div>
        </main>
    </div>
</template>
<script>
    import { ValidationProvider } from 'vee-validate';
    import USBRGAAPService from '../../services/USBRGAAPService/USBRGAAP.service.js';
    import CommonService from '../../services/SharedService/common.service.js';
    import { EnvironmentConfig } from '../../services/constants';
    import AppValidations from "../../services/validation.js";
    import VeeValidate from "vee-validate";
    import Algorithm from '../../services/Algorithm.js';
    export default {
        name: 'USBRGAAPHome',
        data() {
            return {
                selectedBank: '',
                selectedClient: '',
                bankandclientmap: [],
                bankarrayresult: [],
                clientarrayresult: [],
                startdate: '',
                enddate: '',
                formatteddate: '',
                BankclientmappingID: '',
                bankname: '',
                clientname: '',
                dateFormatted: '',
                USUploadedFile: "Choose file (Max file size 100 MB)",
                BRUploadedFile: "Choose file (Max file size 100 MB)",
                renderUSGAAPDiv: false,
                renderBRGAAPDiv: false,
                CITFile: '',
                btnskip: true,
                USFileDetails: [],
                cloneUSFileDetails: [],
                cloneBRFileDetails: [],
                BRFileDetails: [],
                USsheetNames: [],
                BRsheetNames: [],
                isBoxed: true,
                btnDisabled: true,
                baseFiscal: '',
                clientmap: [],
                loading: false,
                btnUSDisabled: true,
                btnBRDisabled: true,
                renderDownloadFileDiv: false,
                generatedFileName: '',
                isDateValid: true,
                isValid: false,
                isSkipUsDisabled: true,
                isSkipBrDisabled: true,
                showGaapError: false,
                fileSize: EnvironmentConfig._FileSize
            }
        },
        created() {
            localStorage.setItem('route', this.$route.name);
            this.loadClientNames();
        },
        components: {
            ValidationProvider,
            VeeValidate
        },
        mixins: [CommonService, AppValidations, USBRGAAPService, Algorithm],
        watch: {
            startdate() {
                if (!this.startdate == "" && !this.enddate == "")
                    this.validateDate(this.startdate, this.enddate);
            },
            enddate() {
                if (!this.startdate == "" && !this.enddate == "")
                    this.validateDate(this.startdate, this.enddate);
            }
        },
        methods: {
            loadClientNames() {
                this.ClientMapping("USBRGAAP").then(response => {
                    if (response) {
                        this.clientmap = response.data;
                    }
                });
            },
            handleUSGAAPFile() {
                this.USGAAPFile = this.$refs.USGAAPFile.files[0];
                this.USUploadedFile = this.USGAAPFile.name;
                this.btnUSDisabled = false;
            },
            handleBRGAAPFile() {
                this.BRGAAPFile = this.$refs.BRGAAPFile.files[0];
                this.BRUploadedFile = this.BRGAAPFile.name;
                this.btnBRDisabled = false;
            },
            formatDate(date) {
                if (!date) return null
                const [year, month, day] = date.split('-')
                return `${month}/${day}/${year}`
            },
            Generate() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.isValid = true
                        this.loading = true;
                        this.showGaapError = false;
                        this.renderDownloadFileDiv = false;
                        this.cloneUSFileDetails.fileType = "usgaap";
                        this.cloneUSFileDetails.AppName = "usgaap";
                        this.cloneUSFileDetails.mappingId = this.selectedClient.id;
                        this.cloneUSFileDetails.startDate = this.startdate;
                        this.cloneUSFileDetails.endDate = this.enddate;
                        this.cloneUSFileDetails.userName = localStorage.getItem('userName');
                        this.cloneUSFileDetails.UserID = localStorage.getItem('userId');
                        this.cloneUSFileDetails.FirstName = localStorage.getItem('firstName');
                        this.cloneUSFileDetails.LastName = localStorage.getItem('lastName');
                        for (var key_USclonesheetDetails in this.cloneUSFileDetails["fileDetails"][0]["sheetDetails"]) {
                            var UScloneSheetName = this.cloneUSFileDetails["fileDetails"][0]["sheetDetails"][key_USclonesheetDetails]["sheetName"];
                            for (var key_USoriginalsheetDetails in this.USFileDetails["fileDetails"][0]["sheetDetails"]) {
                                var USoriginalSheetName = this.USFileDetails["fileDetails"][0]["sheetDetails"][key_USoriginalsheetDetails]["sheetName"];
                                if (UScloneSheetName == USoriginalSheetName) {
                                    this.cloneUSFileDetails.fileDetails[0].sheetDetails[key_USclonesheetDetails].rowEnd = this.USFileDetails.fileDetails[0].sheetDetails[key_USoriginalsheetDetails].rowEnd;
                                    this.cloneUSFileDetails.fileDetails[0].sheetDetails[key_USclonesheetDetails].columnEnd = this.USFileDetails.fileDetails[0].sheetDetails[key_USoriginalsheetDetails].columnEnd;
                                }
                            }
                        }
                        var saveUSJsonArray = JSON.stringify(this.cloneUSFileDetails); // converting array object into json
                        this.cloneBRFileDetails.fileType = "brgaap";
                        this.cloneBRFileDetails.AppName = "brgaap";
                        this.cloneBRFileDetails.mappingId = this.selectedClient.id;
                        this.cloneBRFileDetails.startDate = this.startdate;
                        this.cloneBRFileDetails.endDate = this.enddate;
                        this.cloneBRFileDetails.userName = localStorage.getItem('userName');
                        this.cloneBRFileDetails.UserID = localStorage.getItem('userId');
                        this.cloneBRFileDetails.FirstName = localStorage.getItem('firstName');
                        this.cloneBRFileDetails.LastName = localStorage.getItem('lastName');
                        for (var key_BRclonesheetDetails in this.cloneBRFileDetails["fileDetails"][0]["sheetDetails"]) {
                            var BRcloneSheetName = this.cloneBRFileDetails["fileDetails"][0]["sheetDetails"][key_BRclonesheetDetails]["sheetName"];
                            for (var key_BRoriginalsheetDetails in this.BRFileDetails["fileDetails"][0]["sheetDetails"]) {
                                var BRoriginalSheetName = this.BRFileDetails["fileDetails"][0]["sheetDetails"][key_BRoriginalsheetDetails]["sheetName"];
                                if (BRcloneSheetName == BRoriginalSheetName) {
                                    this.cloneBRFileDetails.fileDetails[0].sheetDetails[key_BRclonesheetDetails].rowEnd = this.BRFileDetails.fileDetails[0].sheetDetails[key_BRoriginalsheetDetails].rowEnd;
                                    this.cloneBRFileDetails.fileDetails[0].sheetDetails[key_BRclonesheetDetails].columnEnd = this.BRFileDetails.fileDetails[0].sheetDetails[key_BRoriginalsheetDetails].columnEnd;
                                }
                            }
                        }
                        var saveBRJsonArray = JSON.stringify(this.cloneBRFileDetails); // converting array object into json
                        var saveJsonArray = "[" + saveUSJsonArray + "," + saveBRJsonArray + "]";
                        this.SaveFileDetails(saveJsonArray).then(Response => {
                            if (!Response.isAxiosError) {
                                if (Response.status == 200) {
                                    this.loading = false;
                                    this.renderDownloadFileDiv = true;
                                    this.generatedFileName = Response.data;
                                }
                            } else {
                                this.showGaapError = true;
                                this.loading = false;
                            }
                        }).catch(function () {
                            this.showGaapError = true;
                            this.loading = false;
                        });
                    }
                })
            }, //end of genereate
            Fetch(event) {
                function deepCopy(oldObj) {
                    var newObj = oldObj;
                    if (oldObj && typeof oldObj === 'object') {
                        newObj = Object.prototype.toString.call(oldObj) === "[object Array]" ? [] : {};
                        for (var i in oldObj) {
                            newObj[i] = deepCopy(oldObj[i]);
                        }
                    }
                    return newObj;
                }
                this.loading = true;
                var buttonId = event.currentTarget.id;
                if (buttonId == 'btnUS') {
                    const formData = new FormData();
                    formData.append("File", this.USGAAPFile);
                    formData.append("FileType", "US GAAP");
                    formData.append("TableName", "[usbrgap].[BaseUSgaapLedger]");
                    formData.append("FirstName", localStorage.getItem('firstName'));
                    formData.append("LastName", localStorage.getItem('lastName'));
                    formData.append("UserName", localStorage.getItem('userName'));
                    this.ImportUploadedFile(formData).then(Response => {
                        if (Response) {
                            this.loading = false;
                            this.USFileDetails = Response.data;
                            this.renderUSGAAPDiv = true;
                            this.isSkipUsDisabled = true;
                            this.cloneUSFileDetails = deepCopy(this.USFileDetails);
                            if (this.cloneUSFileDetails && this.cloneUSFileDetails["fileDetails"][0]["sheetDetails"].length > 1) {
                                this.isSkipUsDisabled = false;
                            }
                            for (var key_fileDetails in this.cloneUSFileDetails["fileDetails"]) {
                                for (var key_sheetDetails in this.cloneUSFileDetails["fileDetails"][key_fileDetails]["sheetDetails"]) {
                                    this.USsheetNames.push(
                                        {
                                            sheetname: this.cloneUSFileDetails["fileDetails"][key_fileDetails]["sheetDetails"][key_sheetDetails]["sheetName"],
                                            Id: this.cloneUSFileDetails["fileDetails"][key_fileDetails]["sheetDetails"][key_sheetDetails]["id"],
                                            parentId: this.cloneUSFileDetails["fileDetails"][key_fileDetails]["id"]
                                        }

                                    );
                                }
                            }
                        }
                    });
                }
                else {
                    const formData = new FormData();
                    formData.append("File", this.BRGAAPFile);
                    formData.append("FileType", "BR GAAP");
                    formData.append("TableName", "[usbrgap].[BaseBrgaapLedger]");
                    formData.append("FirstName", localStorage.getItem('firstName'));
                    formData.append("LastName", localStorage.getItem('lastName'));
                    formData.append("UserName", localStorage.getItem('userName'));
                    var authorizeToken = this.authenticateUser(localStorage.getItem('userName'), EnvironmentConfig._APIURL);
                    this.ImportUploadedFile(formData, authorizeToken).then(Response => {
                        if (Response) {
                            this.loading = false;
                            this.BRFileDetails = Response.data;
                            this.renderBRGAAPDiv = true;
                            this.isSkipBrDisabled = true;
                            this.cloneBRFileDetails = deepCopy(this.BRFileDetails);
                            if (this.cloneBRFileDetails && this.cloneBRFileDetails["fileDetails"][0]["sheetDetails"].length > 1) {
                                this.isSkipBrDisabled = false;
                            }
                            for (var key_fileDetails in this.cloneBRFileDetails["fileDetails"]) {
                                for (var key_sheetDetails in this.cloneBRFileDetails["fileDetails"][key_fileDetails]["sheetDetails"]) {
                                    this.BRsheetNames.push(
                                        {
                                            sheetname: this.cloneBRFileDetails["fileDetails"][key_fileDetails]["sheetDetails"][key_sheetDetails]["sheetName"],
                                            Id: this.cloneBRFileDetails["fileDetails"][key_fileDetails]["sheetDetails"][key_sheetDetails]["id"],
                                            parentId: this.cloneBRFileDetails["fileDetails"][key_fileDetails]["id"]
                                        }
                                    );
                                }
                            }
                        }
                    });
                }
            },
            handleUSSkipEvent(e, FileSheetId) {
                var buttonId = event.currentTarget.id;
                if (buttonId.match(/USskip/g)) {
                    if (document.getElementById('USskip' + FileSheetId).classList.contains('skipbtntype')) {
                        document.getElementById('USskip' + FileSheetId).classList.remove('skipbtntype');
                        document.getElementById('USskip' + FileSheetId).classList.add('skipbtntype1');
                        document.getElementById('USskip' + FileSheetId).textContent = "Add";
                        document.getElementById('USbox' + FileSheetId).style.backgroundColor = "lightgrey";
                        //removing row from cloned array
                        let i = this.cloneUSFileDetails["fileDetails"][0]["sheetDetails"].map(item => item["id"]).indexOf(FileSheetId);
                        this.cloneUSFileDetails["fileDetails"][0]["sheetDetails"].splice(i, 1);
                    }
                    else {
                        document.getElementById('USskip' + FileSheetId).classList.remove('skipbtntype1');
                        document.getElementById('USskip' + FileSheetId).classList.add('skipbtntype');
                        document.getElementById('USskip' + FileSheetId).textContent = "Skip";
                        document.getElementById('USbox' + FileSheetId).style.backgroundColor = "";
                        //adding row back to cloned array
                        var retrievedArray = this.USFileDetails["fileDetails"][0]["sheetDetails"].filter(function (el) {
                            return el["id"] == FileSheetId;
                        });
                        this.cloneUSFileDetails["fileDetails"][0]["sheetDetails"].splice(1, 0, ...retrievedArray);
                    }
                }
            },
            handleBRSkipEvent(e, FileSheetId) {
                var buttonId = event.currentTarget.id;
                if (buttonId.match(/BRskip/g)) {
                    if (document.getElementById('BRskip' + FileSheetId).classList.contains('skipbtntype')) {
                        document.getElementById('BRskip' + FileSheetId).classList.remove('skipbtntype');
                        document.getElementById('BRskip' + FileSheetId).classList.add('skipbtntype1');
                        document.getElementById('BRskip' + FileSheetId).textContent = "Add";
                        document.getElementById('BRbox' + FileSheetId).style.backgroundColor = "lightgrey";
                        //removing row from cloned array
                        let i = this.cloneBRFileDetails["fileDetails"][0]["sheetDetails"].map(item => item["id"]).indexOf(FileSheetId);
                        this.cloneBRFileDetails["fileDetails"][0]["sheetDetails"].splice(i, 1);
                    }
                    else {
                        document.getElementById('BRskip' + FileSheetId).classList.remove('skipbtntype1');
                        document.getElementById('BRskip' + FileSheetId).classList.add('skipbtntype');
                        document.getElementById('BRskip' + FileSheetId).textContent = "Skip";
                        document.getElementById('BRbox' + FileSheetId).style.backgroundColor = "";
                        //adding row back to cloned array
                        var retrievedArray = this.BRFileDetails["fileDetails"][0]["sheetDetails"].filter(function (el) {
                            return el["id"] == FileSheetId;
                        });
                        this.cloneBRFileDetails["fileDetails"][0]["sheetDetails"].splice(1, 0, ...retrievedArray);
                    }
                }
            }
        }
    }
</script>
<style scoped>
    .boxed {
        border: 1px solid rgb(211, 211, 211);
        padding: 10px;
        margin: 10px;
        border-radius: 5px;
    }

    .skipbtntype {
        background-color: #ffe600;
    }

    .skipbtntype1 {
        background-color: grey;
    }

    select {
        /* styling */
        background-color: white;
        border: thin solid grey;
        border-radius: 4px;
        display: inline-block;
        font: inherit;
        line-height: 1.5em;
        padding: 0.5em 3.5em 0.5em 1em;
        /* reset */
        margin: 0;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        -webkit-appearance: none;
        -moz-appearance: none;
        cursor: pointer;
    }

        select.selectarrow {
            background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%), linear-gradient(to right, #ccc, #ccc);
            background-position: calc(100% - 20px) calc(1em + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
            background-size: 5px 5px, 5px 5px, 1px 1.5em;
            background-repeat: no-repeat;
        }

            select.selectarrow:focus {
                background-image: linear-gradient(45deg, green 50%, transparent 50%), linear-gradient(135deg, transparent 50%, green 50%), linear-gradient(to right, #ccc, #ccc);
                background-position: calc(100% - 15px) 1em, calc(100% - 20px) 1em, calc(100% - 2.5em) 0.5em;
                background-size: 5px 5px, 5px 5px, 1px 1.5em;
                background-repeat: no-repeat;
                border-color: green;
                outline: 0;
            }

        select:-moz-focusring {
            color: transparent;
            text-shadow: 0 0 0 #000;
        }

    .homebody {
        background-color: #3333331a;
    }

    .is-invalid {
        border-color: #E84444;
        box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(232,68,68,.6);
    }
</style>
